import React from 'react';
import List from '../../../../ui/organisms/List';
import ProductCardContainer from '../../../ProductCard';

type ProductListViewProps = {
  products: Shopify.ProductEdge[];
  sectionTitle: string;
  linkText: string;
  href: string;
  titleForTracking: string;
  onClick: () => void;
};

const ProductListView: React.FC<ProductListViewProps> = ({
  products,
  sectionTitle,
  linkText,
  href,
  titleForTracking,
  onClick,
}) => (
  <div className="mb-10">
    <List
      headingSpecs={{
        sectionTitle,
        linkText,
        href,
        onClick,
      }}
    >
      {products.map(({ node }) => (
        <ProductCardContainer key={node.id} product={node} titleForTracking={titleForTracking} />
      ))}
    </List>
  </div>
);

export default ProductListView;
